import { ENTITY_FORM_SERVICES } from '@shared/services/entityFormServices';
import { ENTITY_TYPES, IBaseFormService } from '@shared/types';
import { find } from 'lodash';

export const getEntityFormServiceClassByEntityType = (
  entityType: ENTITY_TYPES,
): IBaseFormService<any> => {
  const serviceClass: any = find(
    ENTITY_FORM_SERVICES,
    (service) => service.ENTITY_TYPE === entityType,
  );

  return serviceClass;
};
